
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { ArgsTable, Canvas, Meta, Story } from '@storybook/addon-docs';
import { mediaArgTypes } from '../../objects/media/demo/arg-types.js';
import { avatarArgTypes } from '../avatar/demo/arg-types.js';
import template from './media-link.twig';
const mediaLinkArgTypes = {
  ...mediaArgTypes,
  label: {
    type: { name: 'string' },
    description: 'The text content for the Media Link.',
  },
  href: {
    type: { name: 'string' },
    description: 'The destination URL for the Media Link.',
    table: {
      defaultValue: {
        summary: '#',
      },
    },
  },
  icon: {
    type: { name: 'string' },
    description: 'A key corresponding to one of our compact icons.',
  },
  icon_class: {
    type: { name: 'string' },
    description:
      'Optional class name(s) to append to the icon. Useful for adjusting size or color.',
  },
  action_class: {
    type: { name: 'string' },
    description:
      'Optional class name(s) to append to the action element (the link itself). Useful for applying typographic adjustments.',
  },
  avatar: {
    ...avatarArgTypes.src,
    description:
      'The `src` path for an Avatar component to use as the media object.',
  },
  avatar_alt: avatarArgTypes.alt,
  avatar_width: avatarArgTypes.width,
  avatar_height: avatarArgTypes.height,
  avatar_srcset: avatarArgTypes.srcset,
  avatar_sizes: avatarArgTypes.sizes,
  avatar_size: avatarArgTypes.size,
  avatar_shape: avatarArgTypes.shape,
};


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Components/Media Link" argTypes={mediaLinkArgTypes} mdxType="Meta" />
    <h1>{`Media Link`}</h1>
    <p>{`The Media Link component extends `}<a parentName="p" {...{
        "href": "/docs/objects-media--image"
      }}>{`the Media object`}</a>{` to present a small link with an accompanying image and (optionally) an iconographic affordance. It's useful for capping off a section of content with a link to a related resource: For example, a marketing blurb that links to a case study.`}</p>
    <p>{`The visual object should reduce well while representing the content source: For example, an author image or app icon.`}</p>
    <p>{`If you need more text or more complex visual objects, consider using a `}<a parentName="p" {...{
        "href": "/docs/components-media-summary--event"
      }}>{`Media Summary`}</a>{` or `}<a parentName="p" {...{
        "href": "/docs/components-card--content-blocks"
      }}>{`Card`}</a>{` instead.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Basic" args={{
        href: 'https://cloudfour.com/thinks/performance-is-an-issue-of-equity/',
        label: 'Cloud Four partner Megan Notarte explains why performance is an issue of equity',
        avatar: '/media/megan.png',
        avatar_width: 88,
        avatar_height: 88,
        icon: 'arrow-right'
      }} mdxType="Story">
    {args => template(args)}
  </Story>
    </Canvas>
    <ArgsTable story="Basic" mdxType="ArgsTable" />
    <h2>{`Template Blocks`}</h2>
    <p>{`In addition to the template properties listed above, you may specify the following blocks:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`content`}</inlineCode>{`: The content of the link. If not specified, the `}<inlineCode parentName="li">{`label`}</inlineCode>{` property will be used.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`object`}</inlineCode>{`: The visual object. If not specified, the `}<inlineCode parentName="li">{`avatar`}</inlineCode>{` property will be passed to `}<a parentName="li" {...{
          "href": "/?path=/docs/components-avatar--empty"
        }}>{`the Avatar component`}</a>{` (along with other `}<inlineCode parentName="li">{`avatar_*`}</inlineCode>{` properties).`}</li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const basic = (args => template(args));
basic.storyName = 'Basic';
basic.args = {
  href: 'https://cloudfour.com/thinks/performance-is-an-issue-of-equity/',
  label: 'Cloud Four partner Megan Notarte explains why performance is an issue of equity',
  avatar: '/media/megan.png',
  avatar_width: 88,
  avatar_height: 88,
  icon: 'arrow-right'
};
basic.parameters = { storySource: { source: 'args => template(args)' } };

const componentMeta = { title: 'Components/Media Link', argTypes: mediaLinkArgTypes, includeStories: ["basic"],  };

const mdxStoryNameToKey = {"Basic":"basic"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;